import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'please_select_the_facility'

export const dataPointDefinition = {
  retracedId: 'please_select_the_facility',
  name: "Please select the facility's applicable three letter currency code:",
  description:
    'The intent of this question is to understand which three letter currency code is in use in the country in which the facility is located. Please select the most appropriate currency symbol in use (i.e. BDT, VND, CNY, USD etc.) ',
  meta: {
    slcpMeta: {
      key: 'wb-1',
      number: 'WB-WAGE-1',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wb-1', version: '1.7.0', provider: 'slcp'}],
  sortingId: 34870,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
